// Decorative corner grids behind the not-found page.
//
// This used to be two <img src="/images/shape/grid-01.svg">, and
// `public/images/shape/` does not exist — the directory went with the rest of
// the TailAdmin assets during the re-skin, so both tags rendered as broken
// images with their alt text showing. Drawn in CSS instead: nothing to fetch,
// nothing to lose track of, and it takes the theme's own ink colour.
function Grid({ className }: { className: string }) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute -z-1 h-[250px] w-[250px] xl:h-[450px] xl:w-[450px] ${className}`}
      style={{
        backgroundImage:
          "linear-gradient(to right, currentColor 1px, transparent 1px)," +
          "linear-gradient(to bottom, currentColor 1px, transparent 1px)",
        backgroundSize: "36px 36px",
      }}
    />
  );
}

export default function GridShape() {
  return (
    <>
      <Grid className="right-0 top-0 text-gray-900/[0.06] [mask-image:radial-gradient(120%_120%_at_100%_0%,#000,transparent)] dark:text-white/[0.07]" />
      <Grid className="bottom-0 left-0 text-gray-900/[0.06] [mask-image:radial-gradient(120%_120%_at_0%_100%,#000,transparent)] dark:text-white/[0.07]" />
    </>
  );
}
